import { Component, Input, ViewChild, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexStroke,
  ApexYAxis,
  ApexFill,
  ApexLegend,
  ApexPlotOptions
} from "ng-apexcharts";

import { MonthlyActivity } from "../../../interface/company-client.interface";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  stroke: ApexStroke;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[];
  fill: ApexFill;
  legend: ApexLegend;
};

@Component({
  selector: 'app-activity-summary-chart',
  templateUrl: './activity-summary-chart.component.html',
  styleUrls: ['./activity-summary-chart.component.scss']
})
export class ActivitySummaryChartComponent {
  @ViewChild("chart") chart: ChartComponent;
  @Input() dataSource: MonthlyActivity[];
  public chartOptions: Partial<ChartOptions>;

  constructor(){
    
  }

  ngOnChanges(changes: SimpleChanges){
    this.setChartOptions();
  }

  ngOnInit(){
    this.setChartOptions();
  }

  setChartOptions(){
    this.chartOptions = {
      series: [
        {
          name: "Ventas (MM$)",
          group: "Venta",
          data: this.dataSource.map((item) => item.income),
          color:"#0051a8"
        },
        {
          name: "Notas de Crédito Venta (MM$)",
          group: "Venta",
          data: this.dataSource.map((item) => item.sellCreditNotes),
          color:"#02377066"

        },
        {
          name: "Compras (MM$)",
          group: "Compra",
          data: this.dataSource.map((item) => item.outcome),
          color:"#a80000"

        },
        {
          name: "Notas de Crédito Compra (MM$)",
          group: "Compra",
          data: this.dataSource.map((item) => item.buyCreditNotes),
          color:"#6b000066"

        }
      ],
      chart: {
        type: "bar",
        height: 250,
        stacked: true,
        selection: {
          enabled:false
        }
      },
      stroke: {
        width: 1,
        colors: ["#fff"]
      },
      dataLabels: {
        enabled:false,
        formatter: (val) => {
          return  "" + (Number(val) / 1000000).toFixed(2);
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%"
        }
      },
      xaxis: {
        categories: this.dataSource.map((item) => item.year+"-"+item.month),
        labels:{
          show:true,
          rotate:90
        }
      },
      fill: {
        opacity: 1
      },
      yaxis: {
        labels: {
          formatter: (val) => {
            return "$" + (val / 1000000).toFixed(2);
          }
        }
      },
      legend: {
        position: "top",
        horizontalAlign: "center",
      }
    };
  }
}
